import { connect } from 'react-redux';
import UnsupportedProduct from '../components/unsupported-product';
import { openIfitApps } from '../../../store/ducks/connected-product';

import fusionIcon from '../img/fusion-icon.png';

export default connect(
  () => ({
    appName: 'NordicTrack Fusion CST',
    body: 'Your machine only connects to the Fusion CST tablet app. Tap Continue to select and download the correct app.',
    iconSrc: fusionIcon,
  }),
  dispatch => ({
    handleContinue: () => dispatch(openIfitApps())
  })
)(UnsupportedProduct);
